export const getNewZealandData = () => ({
  name: "Nouvelle-Zélande",
  description: "La Nouvelle-Zélande est un pays viticole moderne et innovant, réputé pour ses vins blancs élégants, notamment le Sauvignon Blanc de Marlborough. Avec ses climats maritimes et ses sols diversifiés, la Nouvelle-Zélande produit des vins de qualité internationale avec une personnalité distincte.",
  type: "country",
  regions: [
    { name: "Marlborough", area: "27,000 ha", percentage: "62%", description: "Sauvignon Blanc emblématique" },
    { name: "Hawke's Bay", area: "4,800 ha", percentage: "11%", description: "Vins rouges et blancs" },
    { name: "Central Otago", area: "2,000 ha", percentage: "5%", description: "Pinot Noir d'altitude" },
    { name: "Wairarapa", area: "1,200 ha", percentage: "3%", description: "Vins de qualité" },
    { name: "Canterbury", area: "1,500 ha", percentage: "3%", description: "Vins frais" },
    { name: "Nelson", area: "1,100 ha", percentage: "3%", description: "Vins aromatiques" },
    { name: "Autres", area: "5,400 ha", percentage: "13%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Marlborough", x: 173.8, y: -41.5, color: "#4B164C", size: 8 },
    { region: "Hawke's Bay", x: 176.8, y: -39.5, color: "#6d2c7a", size: 6 },
    { region: "Central Otago", x: 169.5, y: -45.0, color: "#8a4a8a", size: 4 },
    { region: "Wairarapa", x: 175.5, y: -41.0, color: "#a768a6", size: 3 },
    { region: "Canterbury", x: 172.5, y: -43.5, color: "#c486c4", size: 4 },
    { region: "Nelson", x: 173.0, y: -41.3, color: "#e2a4e2", size: 3 }
  ],
  statistics: {
    totalArea: "43,000 ha",
    production: "3.2 million hectolitres",
    regions: "7 régions principales",
    appellations: "18 appellations",
    exportPercentage: "85%"
  },
  characteristics: {
    climate: "Climats maritimes avec influences océaniques, étés frais et hivers doux",
    soil: "Sols alluviaux, calcaires, argileux, excellente diversité géologique",
    viticulture: "Innovation technologique, viticulture durable, rendements contrôlés"
  },
  wineStyles: {
    red: "Vins rouges élégants et fruités, avec des tanins fins et une excellente fraîcheur",
    white: "Vins blancs frais et aromatiques, avec une acidité vive et des notes tropicales",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture néo-zélandaise remonte à l'arrivée des colons britanniques au XIXe siècle. Les premiers vignobles ont été plantés dans la région d'Auckland. Le Sauvignon Blanc est devenu le cépage emblématique de la Nouvelle-Zélande, particulièrement à Marlborough. Aujourd'hui, la Nouvelle-Zélande est reconnue pour ses vins de qualité et son innovation viticole.",
  foodPairing: "Cuisine néo-zélandaise : fruits de mer, agneau, cuisine fusion, produits locaux. Les vins néo-zélandais s'accordent parfaitement avec la gastronomie internationale et les plats frais."
}); 